import { AlertState, ToastObj } from '@/types/SharedComponent';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: AlertState = {
  toastObj: null,
  loadingBackdrop: 0,
  beatLoader: 0,
};

const alertsSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setToastObj(state, action: PayloadAction<ToastObj | null>) {
      state.toastObj = action.payload;
    },
    showLoadingBackdrop(state) {
      state.loadingBackdrop += 1;
    },
    hideLoadingBackdrop(state) {
      state.loadingBackdrop -= 1;
    },
    setShowBeatLoader(state) {
      state.beatLoader += 1;
    },
    setHideBeatLoader(state) {
      state.beatLoader -= 1;
    },
  },
});

export default alertsSlice.reducer;

export const { setToastObj, showLoadingBackdrop, hideLoadingBackdrop, setShowBeatLoader, setHideBeatLoader } = alertsSlice.actions;
